import './App.css';
import { env } from './env';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useEffect, useState } from 'react';
import { AuthWrapper } from './features/auth/components/AuthWrapper';
import { GlobalStyles } from './shared/styles/core/GlobalStyles';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { ThemeProvider } from '@mui/material/styles';
import { ToastProvider } from './services/toast.service';
import { muiTheme } from './shared/styles/core/mui-theme';

// MSAL configuration
const msalConfig = {
   auth: {
      clientId: env.REACT_APP_AUTH_CLIENT_ID || '',
      authority: 'https://login.microsoftonline.com/' + env.REACT_APP_AUTH_TENANT_ID, // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
      redirectUri: env.REACT_APP_AUTH_REDIRECT_URL || '',
   },
   cache: {
      cacheLocation: 'localStorage', // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
   },
};

export const msalInstance = new PublicClientApplication(msalConfig);

const msalReady = (async () => {
   await msalInstance.initialize();
   const response = await msalInstance.handleRedirectPromise();
   if (response?.account) {
      msalInstance.setActiveAccount(response.account);
   } else if (!msalInstance.getActiveAccount()) {
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
         msalInstance.setActiveAccount(accounts[0]);
      }
   }
})().catch((error) => {
   console.error('MSAL initialization error:', error);
});

const queryClient = new QueryClient({
   defaultOptions: {
      queries: {
         refetchOnWindowFocus: false,
      },
   },
});

function App() {
   const [isInitialized, setIsInitialized] = useState(false);

   useEffect(() => {
      msalReady
         .catch((error) => {
            console.error('MSAL initialization error:', error);
         })
         .finally(() => {
            setIsInitialized(true);
         });
   }, []);

   if (!isInitialized) {
      return null;
   }

   return (
      <MsalProvider instance={msalInstance}>
         <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={muiTheme}>
               <ToastProvider>
                  <GlobalStyles />
                  <AuthWrapper />
               </ToastProvider>
            </ThemeProvider>
         </QueryClientProvider>
      </MsalProvider>
   );
}

export default App;